export default "__VITE_ASSET__Bj2vyZ$C__"